import { includes } from 'ramda';
import { format } from 'date-fns';

import { COUNTRY_CODES } from '../config/constants';

export const buyerAndSellerCountryIsEq = (state, countryCode) => {
  const { seller_address_country_code: sellerCountry, buyer_address_country_code: buyerCountry } = state;

  if (sellerCountry !== buyerCountry) {
    return false;
  }

  if (Array.isArray(countryCode)) {
    return countryCode.includes(sellerCountry);
  }

  return sellerCountry === countryCode;
};

export const countryCodeIsNot = (stateOrCountryCode, countryCode) => {
  const stateCountryCode = typeof stateOrCountryCode === 'string'
    ? COUNTRY_CODES[stateOrCountryCode.toUpperCase()]
    : COUNTRY_CODES[stateOrCountryCode.env.country.toUpperCase()];

  if (Array.isArray(countryCode)) {
    return !countryCode.includes(stateCountryCode);
  }

  return stateCountryCode !== countryCode;
};

export const countryCodeIs = (stateOrCountryCode, countryCode) => {
  const stateCountryCode = typeof stateOrCountryCode === 'string'
    ? COUNTRY_CODES[stateOrCountryCode.toUpperCase()]
    : COUNTRY_CODES[stateOrCountryCode.env.country.toUpperCase()];

  if (Array.isArray(countryCode)) {
    return countryCode.includes(stateCountryCode);
  }

  return stateCountryCode === countryCode;
};

export const defaultInvoiceKind = (country) => {
  if (includes(country, [
    COUNTRY_CODES.PL,
    COUNTRY_CODES.RS,
  ])) {
    return 'invoice';
  }

  return 'vat_invoice';
};

export const defaultInvoiceNumber = () => {
  const formattedDate = format(new Date(), 'yyyyMM');
  return `${formattedDate}0001`;
};
